module.exports = __webpack_public_path__ + "hinted-OpenSansLight-Italic.30c145fb1ae5c0147ca8.woff";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-OpenSansLight-Italic.woff
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-OpenSansLight-Italic.woff
// module chunks = 1